import { extendTailwindMerge } from "tailwind-merge";
import cx from "classnames";
import { encode } from "punycode";
function getCartTotal(props) {
  const {
    appliedAmountIncVat = 0,
    totalGrossAmount = 0,
    totalFreightInclVat = 0
  } = props;
  return totalGrossAmount - totalFreightInclVat + appliedAmountIncVat;
}
const getLatestDate = (date1, date2) => date1 > date2 ? date1 : date2;
const isInStock = (stockStatus) => stockStatus === "StockItem" || stockStatus === "PendingSoldOut";
const formatDateWithLocale = (date, locale = "default") => date.toLocaleDateString(locale, { month: "long", year: "numeric" });
const hasDatePassed = (referenceDate, comparisonDate) => comparisonDate.getTime() < referenceDate.getTime();
function getStockStatusText({
  stockStatus,
  dictionary,
  deliveryMin,
  deliveryMax,
  stockQuantity,
  stockLimit,
  isShortened,
  nextDeliveryDate,
  locale,
  deliveryUnit
}) {
  var _a, _b, _c;
  if (!dictionary)
    return void 0;
  const dateToday = new Date();
  if (!isInStock(stockStatus) && nextDeliveryDate && !hasDatePassed(dateToday, nextDeliveryDate)) {
    if (isShortened) {
      return dictionary.inStockSoon;
    }
    const localeArgument = locale === "eu" ? "en-GB" : locale;
    const formattedDate = formatDateWithLocale(getLatestDate(nextDeliveryDate, dateToday), localeArgument);
    return (_a = dictionary == null ? void 0 : dictionary.onTheWayToUsBackInStock) == null ? void 0 : _a.replace("%X%", formattedDate);
  }
  switch (stockStatus) {
    case "PendingSoldOut":
    case "StockItem":
      if (stockLimit) {
        if (stockQuantity && stockQuantity < stockLimit && dictionary.lessThanInStock) {
          return `${(_b = dictionary.lessThanInStock) == null ? void 0 : _b.replace("%X%", `${stockQuantity}`)}`;
        }
        if (
          // stockQuantity is supposedly passed as undefined from BE when
          // stock status is StockItem and items in stock are > 10
          (stockQuantity && stockQuantity >= stockLimit || stockQuantity === void 0) && dictionary.moreThanStockLimitInStock
        ) {
          return `${(_c = dictionary.moreThanStockLimitInStock) == null ? void 0 : _c.replace("%X%", `${stockLimit}`)}`;
        }
      }
      return dictionary.inStock;
    case "Incoming":
      return dictionary.inStockSoon;
    case "DeliveryItem":
      if (deliveryMin && deliveryMax && deliveryMin !== "undefined" && deliveryMax !== "undefined" && deliveryMin !== "NaN" && deliveryMax !== "NaN") {
        const minAndMax = [deliveryMin, deliveryMax].join("-");
        const unit = deliveryUnit === "week" && dictionary[deliveryUnit] ? dictionary[deliveryUnit] : `${deliveryUnit}s`;
        const estimatedTime = `${dictionary.madeToOrder}: ${dictionary.preliminaryDeliveryTime} ${minAndMax} ${unit}`;
        return estimatedTime;
      }
      return dictionary.madeToOrder;
    case "OutOfStock":
      return dictionary.outOfStock;
    case "SoldOut":
      return dictionary.soldOut;
    default:
      return void 0;
  }
}
const customTwMerge = extendTailwindMerge({
  classGroups: {
    text: ["text-xxs"]
  }
});
const cn = (...inputs) => customTwMerge(cx(...inputs));
const ONCE_PER_DAY = 86400;
const ONCE_PER_EIGHT_HOURS = 28800;
const REVALIDATION_TAGS = {
  // Contentful
  page: "page",
  siteinfo: "siteinfo",
  keyValue: "keyValue",
  dictionary: "dictionary",
  campaign: "campaign",
  editorialPage: "editorialPage",
  landingPage: "landingPage",
  sideMenu: "sideMenu",
  header: "header",
  store: "store",
  productPageInfo: "productPageInfo",
  navigation: "navigation",
  navigationLink: "navigationLink",
  form: "form",
  footerBanner: "footerBanner",
  pageBySlug: (slug) => encode(`page:${slug}`),
  // Can be revalidated by both Loop54 and Contentful
  pageByType: (type) => encode(`pageType:${type}`),
  // Loop
  loopAll: "loop:all",
  flags: "loop:flags",
  productById: (id) => encode(`loop:productById:${id}`),
  productByMainURL: (url) => encode(`loop:productByMainUrl:${url}`),
  brandByCode: (code) => encode(`loop:brandByCode:${code}`),
  designerByCode: (code) => encode(`loop:designerByCode:${code}`),
  categoryByCode: (code) => encode(`loop:categoryByCode:${code}`)
};
export {
  ONCE_PER_DAY,
  ONCE_PER_EIGHT_HOURS,
  REVALIDATION_TAGS,
  cn,
  getCartTotal as getCartTotals,
  getStockStatusText
};
